'use client';

import { NavigateAutomatically } from '@/shared/components';

// temporary page acting as placeholder until we do workspace selection/creation via userDetailsProvider
export default function WorkspaceOpsPage() {
	return <NavigateAutomatically delay={500} />;
}
